import type { DeviceData } from '../types/content-block-types'

export function getDeviceData (): DeviceData | undefined {
  if (typeof window === 'undefined') {
    // We return undefined if we're not in the browser
    return undefined
  }

  const viewportHeight = window.innerHeight
  const isMobile = window.innerWidth < 768

  return {
    type: isMobile ? 'mobile' : 'desktop',
    viewportHeight
  }
}
